import { Alert, Alignment, Button, Classes, Dialog, FormGroup, } from "@blueprintjs/core";
import { DateInput } from "@blueprintjs/datetime";
import { MDBBtn, MDBCol, MDBRow, } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { ILogSefa, ISefaArquivos, newEmpresa, } from "../../model";
import { IEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { TransmissaoStore } from "../../stores/sefip/TransmissaoStore";
import { toast } from "react-toastify";
import { formatMillisToHMS, getMomentFormatter, isExpired } from "../../utils";
import { formatCnpj } from "../../utils";
import { EmpresaSelect, filterEmpresa, renderEmpresa, } from "../empresa/EmpresaSelect";
import { DateRangePicker } from "../utils/DateRangePicker";
import { Pager } from "../utils/Pager";
import { BootstrapTable, SearchField, TableHeaderColumn, } from "react-bootstrap-table";
import ReactJson from "react-json-view";
import MomentLocaleUtils from "react-day-picker/moment";
import { SefaStore } from "../../stores/sefa/SefaStore";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";
import { AppIcon } from "../utils/AppIcon";
import AgendamentoSefa from "./agendamento_sefa";
import SolicitacaoSefa from "./solicitacao_sefa";
import HistoricoSefa from "./historico_sefa";

interface Props { }

interface State {
  date1: string;
  date2: string;
}

@observer
export class SefaPage extends React.Component<Props, State> {

  obs = observable({
    selectedPeriod: [] as any,
    selectedEmpresa: newEmpresa() as IEmpresa,
    open_programar_solicitacoes: false as boolean,
    verSolicitacoes: false as boolean,
    data_download: new Date() as Date,
    is_dataDownload: false as boolean,
    uuid: "" as string,
    arquivosSefa: [] as any,
    current_page: 1 as number,
    loading: false as boolean,
    open_agendamentos: false as boolean,
    sefa_new: false as boolean,
    link_img: "" as string,
    msg_erro: "" as string,
    open_view_img: false as boolean,
  })

  constructor(props) {
    super(props);
    AppStore.setTitle("Solicitações SEFA");

    this.obs.selectedEmpresa = newEmpresa();

    this.state = {
      date1: "",
      date2: ""
    }

    SefaStore.obs.imps = []

  }

  handleDateChange = (val: any) => {
    var string = val.toString();
    var array = string.split(",");

    this.setState({ date1: moment(array[0]).format("YYYY-MM-DD") });
    this.setState({ date2: moment(array[1]).format("YYYY-MM-DD") });

    this.obs.selectedPeriod = val;
  };

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Empresa, Protocolo)"
      />
    );
  };

  handleBuscaClick = async () => {

    if (!this.obs.selectedEmpresa.cnpj) {
      toast.warning('Você precisa selecionar uma empresa para filtrar.', {});
      return
    }

    if (!this.state.date1 || this.state.date1 == "Data inválida") {
      toast.warning('Selecione o período das solicitações.', {});
      return
    }

    if (!this.state.date2 || this.state.date2 == "Data inválida") {
      toast.warning('Selecione o período de agendamento.', {});
      return
    }

    this.obs.loading = true;

    var empresa = this.obs.selectedEmpresa.cnpj;
    var sefa_new = AppStore.obs1.usuario.conta.sefa_new;
    var date1 = this.state.date1;
    var date2 = this.state.date2;

    await SefaStore.length_arquivos(empresa, date1, date2, sefa_new);
    await SefaStore.setBuscaLimite(empresa, date1, date2, this.obs.current_page, 50, sefa_new);

    this.obs.loading = false

  };

  handleBuscaSolicitacoesEmpresa = async (page: number) => {

    var empresa = this.obs.selectedEmpresa.cnpj;
    var sefa_new = AppStore.obs1.usuario.conta.sefa_new;
    var date1 = this.state.date1;
    var date2 = this.state.date2;

    await SefaStore.setBuscaLimite(
      empresa,
      date1,
      date2,
      page,
      50,
      sefa_new
    );

  };

  async handleOpenAgendamentos() {

    SefaStore.obs.page_agendamentos = 1

    await SefaStore.handleIndexAgendamentos(1);

    this.obs.open_agendamentos = true

  }

  async handleOpenHistAgendamentos() {

    await SefaStore.load();

    this.obs.verSolicitacoes = true

  }

  statusFormatter(sol, sefa_new, width) {

    if (sefa_new) {

      return getTag(sol.status, sol.tipo, sol, width);

    } else if (sol.status) {

      return getTag(sol.status, "", sol, width)

    }

    return ""

  }

  formatDateAdd(cell, row) {

    if (!cell) return ""

    return moment(cell).add({ "hours": 3 }).format("DD/MM/YYYY")

  }

  formatDateSubtract(cell, row) {

    if (!cell) return ""

    return moment(cell).subtract({ "hours": 3 }).format("DD/MM/YYYY")

  }

  async handleDownloadImg(chave: string) {

    await SefaStore.downloadImagemError(chave)

  }

  async handleViewImg(chave: string, mensagem: string) {

    let resp = await SefaStore.viewImagemError(chave)

    this.obs.link_img = resp

    this.obs.msg_erro = mensagem

    this.obs.open_view_img = true

  }

  handleErrosTask() {

    if (SefaStore.obs.log_erros.every(item => typeof item === 'string')) {

      return SefaStore.obs.log_erros?.map(x => {

        return <p>{x}</p>;

      })

    }

    return SefaStore.obs.log_erros?.flatMap((erro, index) =>

      Object.entries(erro).map(([chave, mensagem]) => {

        return (<p key={chave}>{index + 1}. {mensagem}

          {chave && <>
            &nbsp;&nbsp;
            <AppIcon name="sim_card_download" onClick={() => this.handleDownloadImg(chave)} size={20} style={{ color: "#3579ea", cursor: "pointer" }} />
          </>}
          &nbsp;&nbsp;
          <AppIcon name="visibility" onClick={() => this.handleViewImg(chave, mensagem)} size={20} style={{ color: "#f57115", cursor: "pointer" }} />

        </p>)

      })

    );

  }

  formatMS(cell, row) {

    if (!cell) return ""

    return formatMillisToHMS(cell)

  }

  onCloseErros() {

    SefaStore.obs.open_erros_sefa = false

    SefaStore.obs.erros_sefa = []

  }

  render() {
    let niveis_acesso = AppStore.obs1.usuario
      ? AppStore.obs1.usuario.niveis_acesso
      : [""];

    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    let items = SefaStore.obs.imps?.map(imp => {
      return ({
        arquivos: imp.arquivos,
        cod_folha: imp.cod_folha,
        competencia: imp.competencia,
        cpf: imp.cpf,
        data_agendamento: imp.data_agendamento,
        data_criacao: moment(imp.data_criacao),
        empresa: imp.empresa,
        cnpj: formatCnpj(imp.empresa),
        erro: imp.erro,
        log_erros: imp.log_erros,
        finalizado: imp.finalizado,
        id: imp.id,
        ie: imp.ie,
        nome: imp.nome,
        origem: imp.origem,
        periodo_final: imp.periodo_final,
        periodo_inicial: imp.periodo_inicial,
        prioridade: imp.prioridade,
        protocolo: imp.protocolo,
        status: imp.status,
        tipo: imp.tipo,
        tipo_folha: imp.folha,
        ultima_atualizacao: imp.ultima_atualizacao,
        uuid: imp.uuid,
        automatico: imp.automatico,
        sefa_new: imp.sefa_new,
        ms: imp.ms
      });
    });

    let empresaText = this.obs.selectedEmpresa.razao_social != ""
      ? `${this.obs.selectedEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectedEmpresa.cnpj)})`
      : "Selecione uma empresa";

    const options = {
      searchField: this.createCustomSearchField,
    };

    const handleDownloadArquivo = async (row: ISefaArquivos, sefa_new) => {

      await SefaStore.downloadArquivoSefa(row.nome, row.id);

    };

    const handleViewDetalhes = async (row: ILogSefa) => {

      SefaStore.obs.view_detalhes = row;

      SefaStore.obs.log_erros = [];

      if (AppStore.obs1.usuario.conta.sefa_new) {

        SefaStore.obs.log_erros = row.log_erros || [];

      } else {

        SefaStore.obs.log_erros = await TransmissaoStore.consultaErro(row.uuid);

      }

      SefaStore.obs.open_view_detalhes = true;

    };

    const handleViewArquivos = (row: ILogSefa, sefa_new: boolean) => {

      if (isExpired(row.data_agendamento)) {
        toast.error("Arquivos indisponíveis. Prazo de 90 dias expirado.")
        return
      }

      this.obs.sefa_new = sefa_new;

      if (sefa_new) {

        if (!row.arquivos || row.arquivos.length == 0) {

          toast.warning('Nenhum arquivo foi encontrado!', {});

        } else {

          this.obs.arquivosSefa = []
          this.obs.uuid = row.id;

          row.arquivos.map(value => {
            let string = value.split('-')
            let filename = string.slice(2).join('-');
            this.obs.arquivosSefa.push({ nome: filename, id: value })
          });

          SefaStore.obs.viewArquivos = true;

        }

      } else {

        if (!row.arquivos || row.arquivos.length == 0) {

          toast.warning('Nenhum arquivo foi encontrado!', {});

        } else {

          this.obs.arquivosSefa = row.arquivos;
          this.obs.uuid = row.uuid;
          SefaStore.obs.viewArquivos = true;

        }
      }

    };

    const handleDownloadAll = async (sefa_new) => {

      if (sefa_new) {

        try {
          const id = this.obs.uuid;
          await SefaStore.download_sefa_zip(id, this.obs.arquivosSefa.map((file) => file.id));
        } catch (error) {
          toast.error("Erro ao realizar o download. Tente novamente.");
        }
      } else {
        try {
          const uuid = this.obs.uuid || "default_uuid";
          const empresa = SefaStore.obs.view_detalhes?.empresa || "default_empresa";
          await TransmissaoStore.downloadArquivosAll(uuid, empresa, "");
        } catch (error) {
          toast.error("Erro ao realizar o download. Tente novamente.");
        }
      }

    };

    function buttonFormatterDetalhes(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => handleViewDetalhes(row)}
          >
            <img src="/images/view.png" width="18px" />
          </MDBBtn>

          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => handleViewArquivos(row, row.sefa_new)}
          >
            <img src="/images/detalhamento.png" width="18px" />
          </MDBBtn>
        </>
      );
    }

    const buttonFormatterArquivo = (cell, row) => {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => handleDownloadArquivo(row, this.obs.sefa_new)}
          >
            <img src="/images/download.svg" />
          </MDBBtn>
        </>
      );
    }

    function geradoFormatter(cell, row) {
      switch (row.automatico) {
        case true:
          return <span className="new-tag-nav-new">Automático</span>
        default:
          return <span className="new-tag-nav">Manual</span>
      }
    }

    return (
      <div>

        <MDBRow>
          <MDBCol xl="8" lg="8" md="8" sm="8" xs="8">
            <MDBRow>
              <MDBCol xl="5" lg="5" md="5" sm="5" xs="5">
                <FormGroup className="empresaSelect" label="Empresa">
                  <EmpresaSelect
                    items={EmpresaStore.sortedEmpresas}
                    itemRenderer={renderEmpresa}
                    itemPredicate={filterEmpresa}
                    onItemSelect={(e: IEmpresa) => this.obs.selectedEmpresa = e}
                    inputProps={{ placeholder: "Filtrar uma empresa" }}
                  >
                    <Button
                      text={empresaText}
                      rightIcon="double-caret-vertical"
                      alignText={Alignment.LEFT}
                    />
                  </EmpresaSelect>
                </FormGroup>
              </MDBCol>
              {!this.obs.is_dataDownload
                ? (
                  <MDBCol xl="4" lg="4" md="4" sm="4" xs="4">
                    <FormGroup label="Período de agendamento" className="inputsPeriodoCalculos">
                      <DateRangePicker
                        onChange={this.handleDateChange}
                        value={this.obs.selectedPeriod}
                      />
                    </FormGroup>
                  </MDBCol>
                )
                : (
                  <MDBCol xl="4" lg="4" md="4" sm="4" xs="4">
                    <FormGroup
                      style={{ marginRight: -300 }}
                      label="Data Solicitação"
                      className="inputsPeriodoCalculos"
                    >
                      <DateInput
                        {...getMomentFormatter("DD/MM/YYYY")}
                        locale="pt-br"
                        dayPickerProps={dayPickerProps}
                        placeholder="DD/MM/AAAA"
                        onChange={(e) => this.obs.data_download = e}
                        value={this.obs.data_download}
                        canClearSelection
                      />
                    </FormGroup>
                  </MDBCol>
                )}

              <MDBCol xl="2" lg="2" md="2" sm="2" xs="2">
                <MDBBtn
                  className="btnDefault btnBuscarNfe mt25"
                  onClick={this.handleBuscaClick}
                  disabled={niveis_acesso.indexOf("h1") == -1}
                >
                  Buscar
                </MDBBtn>
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol md="12" className="btns-Drop" data-tut="manifestacao">
            <MDBBtn
              className="btnDefault btnBuscarNfe"
              onClick={() => this.obs.open_programar_solicitacoes = true}
              style={{ marginRight: 20 }}
            >
              Programar Solicitação
            </MDBBtn>
            <MDBBtn
              className="btnDefault btnBuscarNfe"
              onClick={() => {
                this.handleOpenHistAgendamentos()
              }}
              style={{ marginRight: 20 }}
            >
              Ver Agendados
            </MDBBtn>
            <MDBBtn
              className="btnDefault btnBuscarNfe"
              onClick={() => this.handleOpenAgendamentos()}>
              Agendamentos
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <div data-tut="table">
          <BootstrapTable className="TableDefault" ref="table" data={items} options={options} search data-tut="table">
            <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataField="nome" width="40%">Razão Social</TableHeaderColumn>
            <TableHeaderColumn dataField="empresa" dataFormat={(cell) => formatCnpj(cell)} width="20%">CNPJ</TableHeaderColumn>
            <TableHeaderColumn dataField="cnpj" hidden searchable width="20%">CNPJ</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.formatDateAdd} dataField="data_agendamento" width="20%">Data do Agendamento</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.formatDateAdd} dataField="periodo_inicial" width="15%">Período Inicial</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.formatDateSubtract} dataField="periodo_final" width="15%">Período Final</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.formatMS} dataField="ms" width="15%">Duração</TableHeaderColumn>
            <TableHeaderColumn dataFormat={(cell, row) => this.statusFormatter(row, row.sefa_new, { width: "90%" })} width="25%">Status</TableHeaderColumn>
            <TableHeaderColumn dataFormat={geradoFormatter} width="15%">Origem</TableHeaderColumn>
            <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="15%">Detalhes</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.current_page}
            totalCount={SefaStore.obs.solicitacoesLength}
            pageSize={50}
            onPageChange={page =>
              this.handleBuscaSolicitacoesEmpresa(this.obs.current_page = page)}
          />
        </div>

        <LoadingModal open={SefaStore.obs.loadingViewArquivo} onClose={() => SefaStore.obs.loadingViewArquivo = false} title={"Abrindo arquivo"} />
        <LoadingModal open={TransmissaoStore.obs.loadingArquivo} onClose={() => TransmissaoStore.obs.loadingArquivo = false} title={"Baixando arquivo"} />
        <LoadingModal open={this.obs.loading} onClose={() => this.obs.loading = false} title={"Carregando"} />

        {SefaStore.obs.open_view_detalhes && <Dialog
          usePortal={true}
          isOpen={SefaStore.obs.open_view_detalhes}
          onClose={() => SefaStore.obs.open_view_detalhes = false}
          title="Dados Solicitações"
          className="dados-soli"
        >
          <div className={Classes.DIALOG_BODY}>
            <div style={{ marginBottom: 10 }}>
              <MDBRow>
                <>
                  <MDBCol md="12">
                    <p>
                      <b>Empresa: </b>
                      {SefaStore.obs.view_detalhes.nome}
                    </p>
                    <p>
                      <b>CNPJ: </b>
                      {formatCnpj(SefaStore.obs.view_detalhes.empresa)}
                    </p>
                    <p>
                      <b>CPF: </b>
                      {SefaStore.obs.view_detalhes.cpf ? SefaStore.obs.view_detalhes.cpf.toString().replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : "N/A"}
                    </p>
                    <p>
                      <b>Criado: </b>
                      {moment(SefaStore.obs.view_detalhes.data_criacao).format("DD/MM/YYYY") + " " + moment(SefaStore.obs.view_detalhes.data_criacao).add(3, 'hours').format("HH:mm")}
                    </p>
                    <p>
                      <b>Identificador: </b>
                      {SefaStore.obs.view_detalhes.uuid ? SefaStore.obs.view_detalhes.uuid : "N/A"}
                    </p>
                    <p>
                      <b>Erro: </b>
                      {SefaStore.obs.view_detalhes.erro ? SefaStore.obs.view_detalhes.erro : "Nenhum erro encontrado!"}
                    </p>
                  </MDBCol>

                  <MDBCol md="12">
                    <h3 className="titleProccess titleCnae">Logs Erros</h3>
                    <div style={{ maxHeight: 200, overflow: "auto" }}>
                      {this.handleErrosTask()}
                    </div>
                  </MDBCol>
                </>
              </MDBRow>
            </div>
          </div>
        </Dialog>}

        <Alert
          confirmButtonText="Fechar"
          isOpen={SefaStore.obs.viewArquivos}
          onClose={() => SefaStore.obs.viewArquivos = false}
          canOutsideClickCancel={true}
          className="AlertUser"
        >
          <h2 className="titleSEFAZ">Arquivos</h2>
          <div className="heightArquivos">
            <div style={{ marginBottom: 5, float: "right" }}>
              <Button
                icon="download"
                text="Download Zip"
                loading={TransmissaoStore.obs.loadingArquivoAll}
                className="btn-file btnDefault noMargin"
                onClick={() => handleDownloadAll(this.obs.sefa_new)}
              />
            </div>

            <BootstrapTable
              className="nomeArquivos"
              data={this.obs.arquivosSefa}
              options={options}
              hover
            >
              <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">
                #
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={buttonFormatterArquivo} width="8%">
              </TableHeaderColumn>
              <TableHeaderColumn dataField="nome" dataSort={true} width="50%">
                Arquivos
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </Alert>

        {this.obs.verSolicitacoes &&
          <HistoricoSefa open={this.obs.verSolicitacoes} onClose={() => this.obs.verSolicitacoes = false} />
        }

        {this.obs.open_agendamentos &&
          <AgendamentoSefa open={this.obs.open_agendamentos} onClose={() => this.obs.open_agendamentos = false} />
        }

        {this.obs.open_programar_solicitacoes &&
          <SolicitacaoSefa open={this.obs.open_programar_solicitacoes} onClose={() => this.obs.open_programar_solicitacoes = false} />
        }

        <Dialog
          usePortal={true}
          isOpen={this.obs.open_view_img}
          onClose={() => this.obs.open_view_img = false}
        >
          <div className={Classes.DIALOG_BODY} style={{ textAlign: "center" }}>
            <img
              src={this.obs.link_img}
              alt="Imagem indisponível"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
          <div className={Classes.DIALOG_FOOTER} style={{ textAlign: "center", fontWeight: "bold" }}>
            {this.obs.msg_erro}
          </div>
        </Dialog>

        <Dialog
          usePortal={true} isOpen={SefaStore.obs.open_erros_sefa} onClose={() => this.onCloseErros()} className="alertErros">
          <h2 className="titleSEFAZ">Erros ocorridos durante a Solicitação</h2>
          <p style={{ marginBottom: 25, marginTop: -25 }}>
            Para as empresas listadas abaixo, será necessário realizar novamente a solicitação.
          </p>

          <div style={{ height: 400, overflow: "auto" }}>
            <ReactJson
              collapsed={false}
              displayDataTypes={false}
              src={SefaStore.obs.erros_sefa}
            />
          </div>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" intent="primary" onClick={() => this.onCloseErros()} />
          </div>
        </Dialog>

        <Dialog
          usePortal={true} isOpen={SefaStore.obs.open_erros_sefa_agendamento} onClose={() => SefaStore.obs.open_erros_sefa_agendamento = false} className="alertErros">
          <h2 className="titleSEFAZ">Empresas sem Autenticação</h2>
          <p style={{ marginBottom: 25, marginTop: -25 }}>
            Para continuar com o salvamento do seu agendamento, é necessário remover ou configurar um modelo de autenticação para as empresas listadas abaixo.
            <br/>
            <br/>
            Acesse o menu <b>Empresas → Edição de Empresa → SEFA | e-CAC → Como você deseja se autenticar na SEFA?</b>
          </p>

          <div style={{ height: 400, overflow: "auto" }}>
            <ReactJson
              collapsed={false}
              displayDataTypes={false}
              src={SefaStore.obs.erros_sefa_agendamento}
            />
          </div>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" intent="primary" onClick={() => SefaStore.obs.open_erros_sefa_agendamento = false} />
          </div>
        </Dialog>

      </div>
    );
  }
}

export default SefaPage;
